import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Button, Breadcrumb, InputGroup, Form, OverlayTrigger, Tooltip } from 'react-bootstrap';

import ContactAddContact from './ContactAddContact';
import ContactUpload from './ContactUpload';
import ContactAddContactList from './ContactAddContactList';
import searchIcon from '../../assets/SidebarIcons/icon-search.svg';
import plusIcon from '../../assets/SidebarIcons/icon-plus.svg';
import uploadIcon from '../../assets/SidebarIcons/icon-upload.svg';

const ContactHeading = ({ allTags, contactData, contactList, setSearchQuery }) => {
  const [deleteConfirm, setDeleteConfirm] = useState(false);
  const [openModalAddContact, setOpenModalAddContact] = useState(false);
  const [openModalUpload, setOpenModalUpload] = useState(false);
  const [openModalSegment, setOpenModalSegment] = useState(false);

  const handleDeleteConfirmClose = () => {
    setDeleteConfirm(false);
  };

  const handleOpenAddContactsModal = () => {
    setOpenModalAddContact(true);
  };

  const handleOpenUploadModal = () => {
    setOpenModalUpload(true);
  };

  const handleOpenSegmentModal = () => {
    setOpenModalSegment(true);
  };

  const handleSearchInputKeyPress = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
    }
  };

  const handleSearch = (event) => {
    setSearchQuery(event.target.value);
  };

  return (
    <>
      <div className="page-heading" style={{ padding: "24px 40px" }}>
        <div className="container-left" style={{ marginBottom: "16px"}}>
          <div className="page-title">Contacts</div>
        </div>
        <div className="container-right">
          <InputGroup className="datatable-search">
            <InputGroup.Text>
              <img alt="..." src={searchIcon} />
            </InputGroup.Text>
            <Form.Control
              placeholder="Search"
              onChange={handleSearch}
              onKeyPress={handleSearchInputKeyPress}
            />
          </InputGroup>
          <div className="cta-button-wrapper">
            <Button
              variant="primary"
              style={{ minWidth: 160 }}
              onClick={handleOpenAddContactsModal}
            >
              <img alt="..." src={plusIcon} />
              Add Contact
            </Button>
            <Button
              variant="primary"
              style={{ minWidth: 200 }}
              onClick={handleOpenSegmentModal}
            >
              <img alt="..." src={plusIcon} />
              Create Contact List
            </Button>

            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id="tooltip-name">Import contacts</Tooltip>}
            >
              <Button
                variant="primary"
                style={{ marginRight: '0 0 0 2px' }}
                onClick={handleOpenUploadModal}
              >
                <img alt="..." src={uploadIcon} />
                {/* Upload */}
              </Button>
            </OverlayTrigger>
          </div>
        </div>
      </div>

      <ContactAddContact
        openModalAddContact={openModalAddContact}
        setOpenModalAddContact={setOpenModalAddContact}
        allTags={allTags}
        contactList={contactList}
      />
      <ContactUpload
        contactData={contactData}
        contactList={contactList}
        openModalUpload={openModalUpload}
        setOpenModalUpload={setOpenModalUpload}
      />

      <ContactAddContactList
        openModalSegment={openModalSegment}
        setOpenModalSegment={setOpenModalSegment}
        allTags={allTags}
      />
    </>
  );
};

export default ContactHeading;